import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { Nullable } from 'primeng/ts-helpers';
import { IconKey } from '../../../../../../../whitelabel/icon-key.enum';
import { IconPipe } from '../../../../../../shared/pipes/icon.pipe';
import { SelectTooltipItem } from '../../../../../contract/select-tooltip-item.contract';
import { SelectTooltipPaddings } from '../../../../../contract/select-tooltip-paddings.contract';

@Component({
  selector: 'osp-selected-items-template',
  standalone: true,
  imports: [CommonModule, TranslateModule, TooltipModule, IconPipe],
  templateUrl: './selected-items-template.component.html',
  styleUrl: './selected-items-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedItemsTemplateComponent<T> {
  private paddingStepPx = 10;
  $items = input<T[]>([], { alias: 'items' });
  $title = input('', { alias: 'title' });
  $customTitle = input('', { alias: 'customTitle' });
  $selectedTitle = input<Nullable<string>>('', { alias: 'selectedTitle' });
  $placeholder = input('', { alias: 'placeholder' });
  $filterActive = computed(() => this.$items().length > 0);

  $selectedItems: Signal<SelectTooltipItem[]> = computed(() => {
    return (this.$items()?.length ? this.$items() : []) as SelectTooltipItem[];
  });

  $tooltipPaddings: Signal<{ [key: string]: number }> = computed(() =>
    this.setupChildPadding(this.$items() as SelectTooltipItem[]),
  );

  protected readonly IconKey = IconKey;

  private setupChildPadding(
    items: SelectTooltipItem[],
    padding = 0,
    actualPaddings: SelectTooltipPaddings = {},
  ): SelectTooltipPaddings {
    return [...items].reduce(
      (acc, { key, children }) => ({
        ...acc,
        ...(actualPaddings[key] || acc[key] ? {} : { [key]: padding }),
        ...(children?.length
          ? this.setupChildPadding(children, padding + this.paddingStepPx, { ...actualPaddings, ...acc })
          : {}),
      }),
      {} as SelectTooltipPaddings,
    );
  }
}
